module.exports = __webpack_public_path__ + "img/swiper-9.08af0e14.png";